/*import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DynamicTranslationService {
  private apiKey = '044feb14a195434dbe6f7a9b97ecbe2e';

  private targetLanguage: string = 'en';
  private endpoint: string = `https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&from=en`;

  constructor(private http: HttpClient) { }

  setNavMenuLanguage(lang: string): void {
    this.targetLanguage = lang;
  }

  public translateText(texts: string[]) {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': this.apiKey,
      'Ocp-Apim-Subscription-Region': 'centralus',
      'Content-Type': 'application/json',
    });

    const endpointWithLanguage = `${this.endpoint}&to=${this.targetLanguage}`;
    const requestData = texts.map(text => ({ Text: text, To: this.targetLanguage }));

    return this.http.post(endpointWithLanguage, requestData, { headers: headers }).pipe(
      map((response: any) => response.map((item: { translations: { text: any; }[]; }) => item.translations[0].text))
    );
  }

  public translateObject(inputText: string): Observable<string> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': this.apiKey,
      'Ocp-Apim-Subscription-Region': 'centralus',
      'Content-Type': 'application/json',
    });

    const endpointWithLanguage = `${this.endpoint}&to=${this.targetLanguage}`;
    const requestData = [{ Text: inputText, To: this.targetLanguage }];

    return this.http.post(endpointWithLanguage, requestData, { headers: headers }).pipe(
      map((response: any) => {
        const translatedText = response[0].translations[0].text;
      
        return translatedText;
      })
    );
  }
}
*/

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DynamicTranslationService {
  private targetLanguage: string = 'en';

  constructor(private translateService: TranslateService) {}

  setNavMenuLanguage(lang: string): void {
    this.targetLanguage = lang;
    this.translateService.use(lang);
  }

  public translateText(texts: string[]): Observable<string[]> {
    if (!texts || texts.length === 0) {
      return of([]);
    }

    return this.translateService
      .get(texts)
      .pipe(
        map((res) => texts.map((t) => (res[t] !== undefined ? res[t] : t)))
      );
  }

  public translateObject(inputText: string): Observable<string> {
    if (!inputText) {
      return of(inputText);
    }
    return this.translateService.get(inputText);
  }
}
